import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Button, Input, Popup } from '../../..';
import { PriceListStat, User } from '../../../../../../types';
import { Actions } from '../../../../redux';
import { validatePhone } from '../../../../shared';
import { useLocalStorage } from '../../../../shared/hooks';
import { Buttons, Label, Title } from '../../style';

interface Props {
  stat: PriceListStat;
  user: User;
  vin?: string;
  carId?: number;
  onClose: () => void;
}

export const PopupSendRequestOEM = ({ stat, user, vin, carId, onClose }: Props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [phoneLS, setPhoneLS] = useLocalStorage('user.phone', '');
  const [phoneError, setPhoneError] = useState('');

  useEffect(() => { setPhoneError(''); }, [phoneLS]);

  const statLabels = useMemo(() => (stat ? [
    `${t('We found OEM numbers for')} ${stat.totalWithOems} ${t('out of')} ${stat.total} ${t('items (')}${stat.percent}${t('%) in ')} ${stat.responseTime} ${t('seconds')}`,
    t('Finding the rest of the numbers requires lengthy processing.'),
    t('Do you want to get OEM numbers for the remaining items within 24 hours?'),
    t('If yes - leave a phone number to be notified when the price list is ready.'),
  ] : []), [stat, t]);

  return <>
    <Popup width='400px' onClose={onClose}>
      <Title margin='0 0 10px 0'>{t('Price list is ready')}</Title>
      {statLabels.map((text, i) => <Label key={i} margin='0 0 24px 0'>{text}</Label>)}
      <Input margin='0 0 24px 0' placeholder='Phone*' value={phoneLS} error={phoneError} onChange={(value) => setPhoneLS(value)} />
      <Buttons>
        <Button width='100%' secondary onClick={() => onClose()}>{t('No')}</Button>
        <Button width='100%' wide disabled={!phoneLS} onClick={() => {
          if (!validatePhone(phoneLS)) {
            setPhoneError('Phone is not valid');
            return;
          }

          dispatch(Actions.App.sendTelegramMessage(`New OEM-request:\nUserId: ${user.id}\nEmail: ${user?.email}\nPhone: ${phoneLS}\nCarId: ${carId}\nVIN: ${vin || '-'}`));
          onClose();
        }}>{t('Yes')}</Button>
      </Buttons>
    </Popup>
  </>;
};
